/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    shippingInformationWrapper: {
        '& .d-flex': {
            display: 'flex',
            alignItems: 'center',
        },
        '& img': {
            marginRight: theme.spacing(2),
            position: 'relative',
            top: 4,
            right: 0,
            transform: 'translateY(.6px)',
            animation: 'transitionIn 0.3s',
            width: 28,
            height: 15,
        },
        '& h3': {
            fontSize: 16,
            margin: 0,
            lineHeight: '27px',
            fontFamily: theme.typography.fontFamily,
            fontWeight: 700,
        },
        '& p': {
            margin: '-5px 0',
            fontSize: '9px',
            fontFamily: theme.typography.fontFamily,
        },
        [theme.breakpoints.down(theme.breakpoints.minWidth.small_screen_up)]: {
            display: 'flex',
            minHeight: '34px',
            paddingBottom: '0px',
            background: '#191919',
            color: '#fff',
            '& div.d-flex': {
                margin: '0px auto',
                marginBottom: 0,
                '& img': {
                    top: 0,
                },
                '& h3': {
                    marginTop: 0,
                    marginBottom: 0,
                },
                '& p': {
                    marginTop: '-9px',
                },
            },
        },
    },
}));

const ShippingInformation = ({ isSmallScreen }) => {
    const classes = useStyles();
    const desktopIcon = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt0cd6b63f9c21e8bc/63f64e8743153734d147162f/truck-pdp.svg';
    const mobileIcon = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltb6ec5d196436f52b/63f8bda01be49a10bc1bb047/truck-icon-mobile.svg';
    const LoadImg = isSmallScreen ? mobileIcon : desktopIcon;
    return (
        <div className={classes.shippingInformationWrapper}>
            <div className="d-flex align-items-center">
                <img src={LoadImg} alt="Plant Truck Icon" />
                <div>
                    <h3>All orders over $100 ship free!</h3>
                    <p>*$100 minimium for each shipping address</p>
                </div>
            </div>
        </div>
    );
};

ShippingInformation.propTypes = {
    isSmallScreen: bool.isRequired,
};

export default React.memo(ShippingInformation);
